import { consumer } from '@tock/coretypes';
import SvgBeerGlassFoam from 'components/icons/svgr/quiz/BeerGlassFoam';
import SvgCasualShop from 'components/icons/svgr/quiz/CasualShop';
import SvgCocktailGlass from 'components/icons/svgr/quiz/CocktailGlass';
import SvgFineDining from 'components/icons/svgr/quiz/FineDining';
import SvgFoodStand from 'components/icons/svgr/quiz/FoodStand';
import SvgWaterGlass from 'components/icons/svgr/quiz/WaterGlass';
import SvgWineGlass from 'components/icons/svgr/quiz/WineGlass';

interface OptionImageProps {
  option: consumer.IPatronQuizQuestionOption;
  className?: string;
}

export const OptionImage = ({ option, className }: OptionImageProps) => {
  if (option.displayImage) {
    return (
      <img
        src={option.displayImage.url || ''}
        alt={option.displayText || ''}
        height={option.displayImage.height || undefined}
        width={option.displayImage.width || undefined}
        className={className}
      />
    );
  } else if (option.displayIcon && option.displayIcon.name) {
    const iconComponent = iconNameToComponent[option.displayIcon.name];
    return <div className={className}>{iconComponent}</div>;
  } else {
    return null;
  }
};

const iconNameToComponent: Dictionary<JSX.Element> = {
  BeerGlassFoam: <SvgBeerGlassFoam />,
  CasualShop: <SvgCasualShop />,
  CocktailGlass: <SvgCocktailGlass />,
  FineDining: <SvgFineDining />,
  FoodStand: <SvgFoodStand />,
  WaterGlass: <SvgWaterGlass />,
  WineGlass: <SvgWineGlass />,
};
